import { useShouldOpenPackageInNewTab } from '@ecomm/experiments/ECP-9501/useShouldOpenPackageInNewTab'
import { Link } from '@ecomm/framework/Link'
import type { ReactNode } from 'react'

type RightSideLinkProps = {
  readonly children: ReactNode
  readonly to: string
  readonly onClick: () => void
  readonly className: string
}
export function RightSideLink({
  children,
  onClick,
  to,
  className
}: RightSideLinkProps) {
  const shouldOpenInNewTab = useShouldOpenPackageInNewTab()
  return (
    <Link
      className={className}
      data-testid="rightside-link"
      onClick={onClick}
      to={to}
      target={shouldOpenInNewTab ? '_blank' : '_self'}
    >
      {children}
    </Link>
  )
}
